import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";
import moment from "moment";

export function* handleFetchActivities({ data }) {
  const { search, ...rest } = data;
  // const { project_id } = data;

  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  let searchDatesKeys = [
    "end_date",
    "document_start_date",
    "document_end_date",
    "document_due_data",
    "document_due_end_data",
  ];

  let params = { ...rest, ...(Object.keys(search).length > 0 && { search }) };

  const fd = new FormData();

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
    } else if (key === "template_field" && value.length > 0) {
      value.forEach((ele) => {
        for (const [key1, value1] of Object.entries(ele)) {
          if (key1.includes("date")) {
            fd.append(
              `template_field[][${key1}]`,
              moment(value1).format("DD MMM YYYY")
            );
          } else {
            fd.append(`template_field[][${key1}]`, value1);
          }
        }
      });
    } else if (key === "distributions" || key === "revisions") {
      value.forEach((ele) => {
        for (const [key1, value1] of Object.entries(ele)) {
          if (key1.includes("date")) {
            fd.append(
              `${key}[][${key1}]`,
              moment(value1).format("DD MMM YYYY")
            );
          } else {
            fd.append(`${key}[][${key1}]`, value1);
          }
        }
      });
    } else if (key === "search") {
      for (const [key2, value2] of Object.entries(value)) {
        // console.log("key2, value2", key2, value2);
        if (["document_template_id", "document_status_id"].includes(key2)) {
          value2.forEach((ele) => {
            fd.append(`${key}[${key2}][]`, ele);
          });
        } else if (searchDatesKeys.includes(key2)) {
          fd.append(`search[${key2}]`, moment(value2).format("DD MMM YYYY"));
        } else {
          fd.append(`search[${key2}]`, value2);
        }
      }
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    // const response = yield axios.get(
    //   `${baseURL}/api/v1/document_control/document_control_graph`,
    //   {
    //     params: {
    //       ...rest,
    //       ...(Object.keys(search).length > 0 && { search }),
    //       project_id,
    //     },
    //     // params: { project_id },
    //   }
    // );
    const url = `${baseURL}/api/v1/document_control/document_control_graph?${new URLSearchParams(
      fd
    ).toString()}`;

    const response = yield axios.get(url);
    const { success } = response.data;

    if (success) {
      yield put(actions.fetchProjectActivitiesSuccess(response.data.data));
    } else if (!success) {
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

// export function* handleFetchMaterialControl({ data }) {
//   const { onPermissionError, search, ...rest } = data;

//   Object.keys(search).forEach((key) => {
//     if (search[key]?.length < 1 || search[key] === null) delete search[key];
//   });

//   let searchDatesKeys = [
//     "end_date",
//     "document_start_date",
//     "document_end_date",
//     "document_due_data",
//     "document_due_end_data",
//   ];

//   let params = { ...rest, ...(Object.keys(search).length > 0 && { search }) };

//   const fd = new FormData();

//   for (const [key, value] of Object.entries(params)) {
//     // console.log("key,value", key, value);
//     if (value === null || value === undefined) {
//     } else if (key === "template_field" && value.length > 0) {
//       value.forEach((ele) => {
//         for (const [key1, value1] of Object.entries(ele)) {
//           if (key1.includes("date")) {
//             fd.append(
//               `template_field[][${key1}]`,
//               moment(value1).format("DD MMM YYYY")
//             );
//           } else {
//             fd.append(`template_field[][${key1}]`, value1);
//           }
//         }
//       });
//     } else if (key === "distributions" || key === "revisions") {
//       value.forEach((ele) => {
//         for (const [key1, value1] of Object.entries(ele)) {
//           if (key1.includes("date")) {
//             fd.append(
//               `${key}[][${key1}]`,
//               moment(value1).format("DD MMM YYYY")
//             );
//           } else {
//             fd.append(`${key}[][${key1}]`, value1);
//           }
//         }
//       });
//     } else if (key === "search") {
//       for (const [key2, value2] of Object.entries(value)) {
//         // console.log("key2, value2", key2, value2);
//         if (["document_template_id", "document_status_id"].includes(key2)) {
//           value2.forEach((ele) => {
//             fd.append(`${key}[${key2}][]`, ele);
//           });
//         } else if (searchDatesKeys.includes(key2)) {
//           fd.append(`search[${key2}]`, moment(value2).format("DD MMM YYYY"));
//         } else {
//           fd.append(`search[${key2}]`, value2);
//         }
//       }
//     } else if (value !== null && value !== undefined) {
//       fd.append(key, value);
//     }
//   }

//   try {
//     const url = `${baseURL}/api/v1/document_control?${new URLSearchParams(
//       fd
//     ).toString()}`;

//     const response = yield axios.get(url);
//     const { success } = response.data;

//     if (success) {
//       const { permissions } = response.data.data;
//       if (permissions?.document_control?.view) {
//         yield put(actions.fetchMaterialControlSuccess(response.data.data));
//       } else {
//         return onPermissionError();
//       }
//     } else if (!success) {
//       yield put(actions.fetchMaterialControlError());
//       errorHandler(response.data);
//     }
//   } catch (error) {
//     AntdAlert.error("Something went wrong!");
//     yield put(actions.fetchMaterialControlError());
//     console.log(error);
//   }
// }

export function* handleBatchUpdate({ data }) {
  let searchDatesKeys = [
    "end_date",
    "document_start_date",
    "document_end_date",
  ];

  const fd = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (value === null || value === undefined) {
    } else if (key === "document_control" && value.length > 0) {
      // console.log("value", value);
      value.forEach((ele) => {
        fd.append(`${key}[]`, ele);
      });
    } else if (key === "template_field" && value.length > 0) {
      value.forEach((ele) => {
        for (const [key1, value1] of Object.entries(ele)) {
          if (key1.includes("date")) {
            fd.append(
              `template_field[][${key1}]`,
              moment(value1).format("DD MMM YYYY")
            );
          } else {
            fd.append(`template_field[][${key1}]`, value1);
          }
        }
      });
    } else if (key === "defaultField" && value.length > 0) {
      value.forEach((ele) => {
        for (const [key1, value1] of Object.entries(ele)) {
          if ([0, 4].includes(key1)) {
            fd.append(
              `defaultField[][${key1}]`,
              moment(value1).format("DD MMM YYYY")
            );
          } else {
            fd.append(`defaultField[][${key1}]`, value1);
          }
        }
      });
    } else if (key === "distributions" || key === "revisions") {
      value.forEach((ele) => {
        for (const [key1, value1] of Object.entries(ele)) {
          if (key1.includes("date")) {
            fd.append(`${key}[${key1}]`, moment(value1).format("DD MMM YYYY"));
          } else {
            fd.append(`${key}[${key1}]`, value1);
          }
        }
      });
    } else if (key === "search") {
      for (const [key2, value2] of Object.entries(value)) {
        // console.log("key2, value2", key2, value2);
        if (["document_template_id", "document_status_id"].includes(key2)) {
          value2.forEach((ele) => {
            fd.append(`${key}[${key2}][]`, ele);
          });
        } else if (searchDatesKeys.includes(key2)) {
          fd.append(`search[${key2}]`, moment(value2).format("DD MMM YYYY"));
        } else {
          fd.append(`search[${key2}]`, value2);
        }
      }
    } else if (key === "revisions_ids" || key === "distributions_ids") {
      if (value?.length > 0) {
        value.map((id) => fd.append(`${key}[]`, id));
      }
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    const url = `${baseURL}/api/v1/document_control/batch_update?${new URLSearchParams(
      fd
    ).toString()}`;

    const response = yield axios.post(url);
    const { success, message } = response.data;

    if (success) {
      yield put(actions.fetchProjectBatchUpdateSuccess(response.data.data));
      AntdAlert.success(message);
    } else if (!success) {
      yield put(actions.fetchProjectBatchUpdateError());
      AntdAlert.error(message || "Something went wrong!");
      errorHandler(response.data);
    }
  } catch (error) {
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

/**
 * Saga handler for fetching project completion data
 * This fetches the workflow stage completion percentages for materials and bolts
 */
export function* handleFetchProjectCompletionData({ data, searchResultIds }) {
  try {
    const { project_id } = data;
    
    // Build the API URL with project_id
    let url = `${baseURL}/material-control-registers/completion-stats?projectId=${project_id}`;
    
    // If search result IDs are provided, add them to the request
    if (searchResultIds && Array.isArray(searchResultIds) && searchResultIds.length > 0) {
      // Add the search result IDs as a comma-separated list
      url += `&ids=${searchResultIds.join(',')}`;
    }
    
    // Make API call to fetch project completion data
    const response = yield axios.get(url);
    
    if (response.status === 200) {
      // Dispatch success action with the completion data
      yield put(actions.fetchProjectCompletionDataSuccess(response.data));
    } else {
      // Handle API error response
      errorHandler(response.data);
      yield put(actions.fetchProjectCompletionDataError());
    }
  } catch (error) {
    // Handle any exceptions
    console.log('Error fetching project completion data:', error);
    AntdAlert.error("Failed to fetch workflow completion data");
    yield put(actions.fetchProjectCompletionDataError());
  }
}

export function* handleFetchActivitiesUtilsData({ data }) {
  try {
    const response = yield axios.get(
      `${baseURL}/api/v1/sales_activities/search_lists`
    );
    const { success } = response.data;

    if (success) {
      yield put(
        actions.fetchProjectActivitiesSearchUtilsSuccess(response.data.data)
      );
    } else if (!success) {
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateActivity({ data }) {
  const { id, debouncedDefaultPageOneCallApi, ...res } = data;

  const fd = new FormData();
  for (const [key, value] of Object.entries(res)) {
    if (key === "images" && value !== undefined) {
      Array.from(value).forEach((image) => {
        const { isLocal } = image;
        if (isLocal) {
          fd.append(`attachments[]`, image);
        }
        // else fd.append("image_ids[]", key);
      });
    } else if (key === "field_values") {
      Object.entries(value).map((entry, i) => {
        // if (
        //   entry[1] !== null &&
        //   entry[1] !== undefined
        //   //  && entry[1]?.length > 0
        // ) {
        fd.append(`field_values[][id]`, entry[0]);
        fd.append(`field_values[][value]`, entry[1]);
        // }
      });
    } else if (value !== null && value !== undefined) {
      fd.append(key, value);
    }
  }

  try {
    const response = yield axios.put(
      `${baseURL}/api/v1/document_control/${id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectActivitySuccess(response.data.data));
      debouncedDefaultPageOneCallApi();
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateProjectActivityError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateProjectActivityError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleFetchMaterialControl({ data }) {
  const { projectId, search, onPermissionError, orderBy, orderDirection, page, perPage, filter, type, materialControlFilters, materialTemplateId, materialTemplateFields } = data;
  try {
    // Start with base params
    let params = {
      projectId,
      page: page || 1,
      perPage: perPage || 10
    };
    
    // Add orderBy and orderDirection only if they are provided
    if (orderBy) {
      params.orderBy = orderBy;
    }
    
    if (orderDirection) {
      params.orderDirection = orderDirection;
    }

    // Backward compatibility: accept legacy sort/order keys
    if (!params.orderBy && data && data.sort) {
      params.orderBy = data.sort;
    }
    if (!params.orderDirection && data && data.order) {
      params.orderDirection = data.order;
    }
    
    // Add filter parameters if filter is true
    if (filter === true) {
      // Add type parameter
      if (type) {
        params.type = type;
      }
      
      // Add materialTemplateId if available
      if (materialTemplateId) {
        params.materialTemplateId = materialTemplateId;
      }
      
      // Extract filter values from materialControlFilters array and add them directly to params
      if (materialControlFilters && materialControlFilters.length > 0) {
        console.log('Processing materialControlFilters:', materialControlFilters);
        
        // Each item in materialControlFilters is an object with a single key-value pair
        // We need to extract these and add them directly to the params
        materialControlFilters.forEach(filterItem => {
          // Get the first (and only) key from the filter item
          const key = Object.keys(filterItem)[0];
          const value = filterItem[key];
          
          // Only add if the value is not empty
          if (value !== undefined && value !== null && value !== '') {
            params[key] = value;
            console.log(`Added filter parameter: ${key}=${value}`);
          }
        });
      }

      if (materialTemplateFields && Object.keys(materialTemplateFields).length > 0) {
        
        // Create a nested structure for materialTemplateFields in the URL
        // This will result in: materialTemplateFields[field_name]=value
        Object.entries(materialTemplateFields).forEach(([fieldName, fieldValue]) => {
          // Only add if the value is not empty
          if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
            // Format the parameter name as materialTemplateFields[fieldName]
            params[`materialTemplateFields[${fieldName}]`] = fieldValue;
          }
        });
      }
    }
    
    // Add search parameters if they exist
    if (search) {
      // Handle area array specially
      if (search.area && Array.isArray(search.area) && search.area.length > 0) {
        params.area = search.area.join(',');
      }
      
      // Handle tracking status arrays
      const trackingStatusFields = [
        'fabricationStatuses',
        'qcReleaseStatuses',
        'corrosionProtectionStatuses',
        'deliveryToSiteStatuses',
        'siteReceiptStatuses'
      ];
      
      trackingStatusFields.forEach(field => {
        if (search[field] && Array.isArray(search[field]) && search[field].length > 0) {
          // Convert array to JSON string for URL parameter
          params[field] = JSON.stringify(search[field]);
        }
      });
      
      // Add other search parameters if they have values
      const searchFields = ['assemblyNo', 'revision', 'uniqueId', 'qty', 'materialType', 'totalGross', 'priorityId', 'perComplete', 'perInstalled'];
      searchFields.forEach(field => {
        if (search[field]) {
          if (field === 'priorityId' || typeof search[field] === 'number') {
            // Handle numeric values
            params[field] = search[field];
          } else if (typeof search[field] === 'string' && search[field].trim() !== '') {
            // Handle string values
            params[field] = search[field];
          }
        }
      });
    }
    
    // Convert params object to URL query string
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      queryParams.append(key, value);
    });
    
    const response = yield axios.get(`${baseURL}/material-control-registers?${queryParams.toString()}`);
    if (response.status === 200) {
      yield put(actions.fetchMaterialControlSuccess(response.data));
    } else {
      yield put(actions.fetchMaterialControlError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchMaterialControlError());
    AntdAlert.error("Something went wrong!");
    if (error.response && error.response.status === 403 && onPermissionError) {
      onPermissionError();
    }
  }
}

export function* handleDeleteMaterialControl({ data }) {
  const { id, onDeleteSuccess } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/material-control-registers/${id}`
    );
    if (response.status === 200) {
      AntdAlert.success("Material Control deleted successfully");
      yield put(actions.deleteMaterialControlSuccess(response.data));
      onDeleteSuccess();
    } else {
      AntdAlert.error(response.data.message);
      yield put(actions.deleteMaterialControlError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteMaterialControlError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

// export function* handleCreateMaterialControl({ data }) {
//   console.log("handleCreateMaterialControl", data);

//   const fd = new FormData();

//   const { debouncedDefaultPageOneCallApi, ...res } = data;

//   for (const [key, value] of Object.entries(res)) {
//     if (key === "images" && value !== undefined) {
//       Array.from(value).forEach((image) => {
//         fd.append(`attachments[]`, image);
//       });
//     } else if (key === "field_values") {
//       Object.entries(value).map((entry, i) => {
//         // if (
//         //   entry[1] !== null &&
//         //   entry[1] !== undefined &&
//         //   entry[1]?.length > 0
//         // ) {
//         fd.append(`field_values[][id]`, entry[0]);
//         fd.append(`field_values[][value]`, entry[1]);
//         // }
//       });
//     } else if (value !== null && value !== undefined) {
//       fd.append(key, value);
//     }
//   }

//   try {
//     const response = yield axios.post(
//       `${baseURL}/material-control-registers`,
//       fd,
//       {
//         headers: {
//           "content-type": "multipart/form-data",
//         },
//       }
//     );
    
//     const { success, message } = response.data;
//     if (success) {
//       AntdAlert.success(message);
//       yield put(actions.createMaterialControlSuccess(response.data.data));
//       debouncedDefaultPageOneCallApi();
//       // Call the onSuccess callback if provided
//       if (onSuccess && typeof onSuccess === 'function') {
//         onSuccess();
//       }
//     } else if (!success) {
//       AntdAlert.error(response.data?.errors[0]);
//       yield put(actions.createMaterialControlError());
//       errorHandler(response.data);
//       // Call the onError callback if provided
//       if (onError && typeof onError === 'function') {
//         onError(response.data);
//       }
//     }
//   } catch ({ response }) {
//     yield put(actions.createMaterialControlError());
//     AntdAlert.error("Something went wrong!");
//     // Call the onError callback if provided
//     if (onError && typeof onError === 'function') {
//       onError(response);
//     }
//   }
// }

export function* handleCreateMaterialControl({ data }) {
  try {
    const { debouncedDefaultPageOneCallApi, onSuccess, onError, ...rest } = data;
    console.log("rest", rest);
    
    // Check if documents (files) are present
    let requestData;
    let headers = {};
    
    if (rest.documents && rest.documents.length > 0) {
      // Create FormData for file upload
      const formData = new FormData();
      
      // Add all fields except documents to FormData
      Object.keys(rest).forEach(key => {
        if (key !== 'documents' && rest[key] !== null && rest[key] !== undefined) {
          // Handle objects by JSON stringifying them
          if (typeof rest[key] === 'object' && rest[key] !== null) {
            formData.append(key, JSON.stringify(rest[key]));
          } else {
            formData.append(key, rest[key]);
          }
        }
      });
      
      // Add files to FormData
      rest.documents.forEach((file) => {
        formData.append('documents', file);
      });
      
      requestData = formData;
      headers['Content-Type'] = 'multipart/form-data';
    } else {
      requestData = rest;
      headers['Content-Type'] = 'application/json';
    }
    
    const response = yield axios.post(`${baseURL}/material-control-registers`, requestData, {
      headers
    });
    if (response.status === 201) {
      AntdAlert.success("Material Control Created Successfully");
      
      // Check if the data object includes an id field
      const closeMainForm = rest && rest.id ? true : false;
      // Pass the response data and a boolean indicating if the original data had an id
      yield put(actions.createMaterialControlSuccess(response.data, closeMainForm));
      
      // Call the success callback if provided
      if (typeof onSuccess === 'function') {
        onSuccess(response.data);
      }
      
      // Don't automatically refresh data after creation
      // This would cause the expanded row to close
      // The component will handle refreshing data when needed
      // if (typeof debouncedDefaultPageOneCallApi === 'function') {
      //   debouncedDefaultPageOneCallApi();
      // }
    } else {
      AntdAlert.error(response.data?.message || "Something went wrong!");
      yield put(actions.createMaterialControlError());
      errorHandler(response.data);
      
      // Call the error callback if provided
      if (typeof onError === 'function') {
        onError(response.data);
      }
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createMaterialControlError());
    AntdAlert.error(error.response?.data?.message || "Something went wrong!");
    errorHandler(error);
    
    // Call the error callback if provided
    if (typeof data.onError === 'function') {
      data.onError(error);
    }
  }
}


export function* handleUpdateMaterialControl({ data }) {
  try {
    const { debouncedDefaultPageOneCallApi, onSuccess, onError, ...rest } = data;
    console.log("Updating material control with data:", rest);
    
    // Check if documents (files) are present
    let requestData;
    let headers = {};
    
    if (rest.documents && rest.documents.length > 0) {
      // Create FormData for file upload
      const formData = new FormData();
      
      // Add all fields except documents to FormData
      Object.keys(rest).forEach(key => {
        if (key !== 'documents' && rest[key] !== null && rest[key] !== undefined) {
          // Handle objects by JSON stringifying them
          if (typeof rest[key] === 'object' && rest[key] !== null) {
            formData.append(key, JSON.stringify(rest[key]));
          } else {
            formData.append(key, rest[key]);
          }
        }
      });
      
      // Add files to FormData
      rest.documents.forEach((file) => {
        formData.append('documents', file);
      });
      
      requestData = formData;
      headers['Content-Type'] = 'multipart/form-data';
    } else {
      requestData = rest;
      headers['Content-Type'] = 'application/json';
    }
    
    const response = yield axios.patch(`${baseURL}/material-control-registers/${rest.id}`, requestData, {
      headers
    });
    if (response.status === 200) {
      AntdAlert.success("Material Control Updated Successfully");
      yield put(actions.updateMaterialControlSuccess(response.data));
      console.log("Update successful:", response.data);
      
      // Call the success callback if provided
      if (typeof onSuccess === 'function') {
        onSuccess(response.data);
      }
      
      // // Refresh the data
      // if (typeof debouncedDefaultPageOneCallApi === 'function') {
      //   debouncedDefaultPageOneCallApi();
      // }
    } else {
      AntdAlert.error(response.data?.message || "Something went wrong!");
      yield put(actions.updateMaterialControlError());
      errorHandler(response.data);
      
      // Call the error callback if provided
      if (typeof onError === 'function') {
        onError(response.data);
      }
    }
  } catch (error) {
    console.log("Error updating material control:", error);
    yield put(actions.updateMaterialControlError());
    AntdAlert.error(error.response?.data?.message || "Something went wrong!");
    errorHandler(error);
    
    // Call the error callback if provided
    if (typeof data.onError === 'function') {
      data.onError(error);
    }
  }
}

export function* handleDeleteProjectDocAttach({ data }) {
  const { key, recordId } = data;
  let params = {
    id: key,
  };

  try {
    const response = yield axios.delete(
      `${baseURL}/attachments/${key}`,
      { params }
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(
        actions.deleteProjectDocAttachSuccess({
          recordId,
          imgItem: response.data.data,
        })
      );
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteProjectDocAttachError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectDocAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
  }
}

export function* handleAddActivityAttach({ data }) {
  const { setCurrentUpdateObj } = data;

  const { id, images } = data.data;

  const fd = new FormData();
  Array.from(images).forEach((image) => {
    const { isLocal } = image;
    if (isLocal) {
      fd.append(`attachments[]`, image);
    }
  });

  try {
    const response = yield axios.patch(
      `${baseURL}/api/v1/document_control/${id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectActivitySuccess(response.data.data));
      setCurrentUpdateObj(response.data.data);
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateProjectActivityError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateProjectActivityError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleMarkItemAsReceived({ data }) {
  const { materialControlRegisterId, attachments, ...rest } = data.data;
  
  try {
    // First, create the progress step
    const response = yield axios.post(`${baseURL}/material-control-registers/${materialControlRegisterId}/progress-steps`, rest);
    
    if (response.status === 201) {
      
      // If there are attachments, upload them to the newly created progress step
      if (attachments && attachments.length > 0) {
        
        try {
          const progressStepId = response.data.id; // Get the ID of the newly created progress step
          
          // Upload each attachment
          for (const attachment of attachments) {
            const formData = new FormData();
            formData.append('attachableType', 'ProgressStep');
            formData.append('attachableId', progressStepId);
            formData.append('documents', attachment.file);
            
            // Add additionalData if present
            if (attachment.additionalData) {
              formData.append('additionalData', JSON.stringify(attachment.additionalData));
            }
            
            const attachmentResponse = yield axios({
              method: 'POST',
              url: `${baseURL}/attachments`,
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
            
          }
          
        } catch (attachmentError) {
          console.error("Error uploading attachments:", attachmentError);
          // Don't fail the entire operation if attachment upload fails
          AntdAlert.error("Progress step created but some attachments failed to upload");
        }
      }
      
      yield put(actions.markItemAsReceivedSuccess(response.data));
      
      // After successful mark as received, fetch the updated material control data
      try {
        const materialControlResponse = yield axios.get(`${baseURL}/material-control-registers/${materialControlRegisterId}`);
        if (materialControlResponse.status === 200) {
          yield put(actions.fetchMaterialControlByIdSuccess(materialControlResponse.data));
        }
      } catch (error) {
        console.log("Error fetching material control after marking as received:", error);
      }
    } else {
      AntdAlert.error(response.data.message);
      yield put(actions.markItemAsReceivedError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.markItemAsReceivedError(response.data));
    console.log(response);
  }
}

export function* handleMarkItemAsReceivedUpdate({ data }) {
  const { materialControlRegisterId, progressStepId, ...rest } = data.data;
  try {
    const response = yield axios.patch(`${baseURL}/material-control-registers/${materialControlRegisterId}/progress-steps/${progressStepId}`, rest);
    if (response.status === 200) {
      yield put(actions.markItemAsReceivedSuccess(response.data));
    } else {
      yield put(actions.markItemAsReceivedError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.markItemAsReceivedError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleMarkItemAsCompleted({ data }) {
  const { materialControlRegisterId, progressStepId, projectId, refetchParams, ...rest } = data.data;
  try {
    const response = yield axios.patch(`${baseURL}/material-control-registers/${materialControlRegisterId}/progress-steps/${progressStepId}`, rest);
    if (response.status === 200) {
      yield put(actions.markItemAsCompletedSuccess(response.data));
      
      // After successful mark as completed, fetch the updated material control data
      try {
        const materialControlResponse = yield axios.get(`${baseURL}/material-control-registers/${materialControlRegisterId}`);
        if (materialControlResponse.status === 200) {
          yield put(actions.fetchMaterialControlByIdSuccess(materialControlResponse.data));
        }
      } catch (error) {
        console.log("Error fetching material control after marking as completed:", error);
      }
      
      // Refetch the main table data to reflect the changes
      if (refetchParams && projectId) {
        try {
          yield put(actions.fetchMaterialControl({
            projectId: projectId,
            page: refetchParams.page || 1,
            perPage: (refetchParams.perPage ?? refetchParams.per_page ?? 10),
            search: refetchParams.search || {},
            orderBy: refetchParams.sort,
            orderDirection: refetchParams.order,
            onPermissionError: refetchParams.onPermissionError
          }));
        } catch (error) {
          console.log("Error refetching material control list after marking as completed:", error);
        }
      }
    } else {
      yield put(actions.markItemAsCompletedError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.markItemAsCompletedError(response.data));
    console.log(response);
  }
}

  